import React from "react";
import {formatEuroWhole} from "./format.js";

/**
 * Jahresspalten (volle Vorjahre), laufendes Jahr und Hochrechnung als
 * gemeinsame Zellenfolge - genutzt von Gesamt, Drilldown, Vertreter × Monat,
 * Kundenrangliste und Kundensicht, damit Beträge überall gleich aussehen
 * (Euro ohne Nachkommastellen, siehe format.js).
 */
export default function YearValueCells({years, current, hr, pastYears, hideHr = false, hideCurrent = false}) {
    return (
        <>
            {pastYears.map((year) => (
                <td key={year} className="text-end text-nowrap">{formatEuroWhole(years?.[year])}</td>
            ))}
            {!hideCurrent && <td className="text-end text-nowrap">{formatEuroWhole(current)}</td>}
            {!hideHr && <td className="text-end text-nowrap fw-semibold">{formatEuroWhole(hr)}</td>}
        </>
    );
}
